import React from "react";

const NotFoundIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="104.522" height="97.712" className="not-found-icon">
    <g id="Group_4676" data-name="Group 4676" transform="translate(-572 -249.355)">
      <g id="Group_4668" data-name="Group 4668" transform="translate(572 249.355)">
        <path
          id="Path_512"
          d="M419.5 818.386a37.144 37.144 0 10-37.136-37.133 37.145 37.145 0 0037.136 37.133z"
          fill="#ee4023"
          data-name="Path 512"
          transform="translate(-367.515 -720.674)"
        />
        <g id="Group_4663" data-name="Group 4663" transform="translate(50.089)">
          <path
            id="Rectangle_1453"
            d="M0 0h3.782v18.481H0z"
            fill="#ee4023"
            data-name="Rectangle 1453"
            transform="rotate(-.065 3.526 .002)"
          />
        </g>
        <g id="Group_4664" data-name="Group 4664" transform="translate(71.56 6.955)">
          <path
            id="Rectangle_1454"
            d="M0 0h18.598v3.783H0z"
            fill="#ee4023"
            data-name="Rectangle 1454"
            transform="rotate(-60.954 13.814 8.13)"
          />
        </g>
        <g id="Group_4665" data-name="Group 4665" transform="translate(86.803 28.169)">
          <path
            id="Rectangle_1455"
            d="M0 0h18.479v3.784H0z"
            fill="#ee4023"
            data-name="Rectangle 1455"
            transform="rotate(-31.57 17.124 4.837)"
          />
        </g>
        <g id="Group_4666" data-name="Group 4666" transform="translate(20.656 6.818)">
          <path
            id="Rectangle_1456"
            d="M0 0h3.784v18.426H0z"
            fill="#ee4023"
            data-name="Rectangle 1456"
            transform="rotate(-29.2 3.543 .922)"
          />
        </g>
        <g id="Group_4667" data-name="Group 4667" transform="translate(0 27.974)">
          <path
            id="Rectangle_1457"
            d="M0 0h3.783v18.35H0z"
            fill="#ee4023"
            data-name="Rectangle 1457"
            transform="rotate(-59.23 2.859 1.625)"
          />
        </g>
      </g>
      <path
        id="Path_521"
        d="M10.874 0c6.005 0 10.874 4.278 10.874 9.556.079-.081-21.7.027-21.747 0C0 4.278 4.868 0 10.874 0z"
        fill="#ececec"
        data-name="Path 521"
        transform="translate(613 317.819)"
      />
      <g id="Group_4677" data-name="Group 4677" transform="translate(0 4)">
        <circle
          id="Ellipse_131"
          cx="4"
          cy="4"
          r="4"
          fill="#ececec"
          data-name="Ellipse 131"
          transform="translate(604 292.035)"
        />
        <circle
          id="Ellipse_132"
          cx="4"
          cy="4"
          r="4"
          fill="#ececec"
          data-name="Ellipse 132"
          transform="translate(636 292.035)"
        />
      </g>
    </g>
  </svg>
);

export default NotFoundIcon;
